import React from "react";

const Cancel = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.7074 0.3025C13.3174 -0.0874998 12.6874 -0.0874998 12.2974 0.3025L7.40744 5.1825L2.51744 0.2925C2.12744 -0.0975 1.49744 -0.0975 1.10744 0.2925C0.717441 0.6825 0.717441 1.3125 1.10744 1.7025L5.99744 6.5925L1.10744 11.4825C0.717441 11.8725 0.717441 12.5025 1.10744 12.8925C1.49744 13.2825 2.12744 13.2825 2.51744 12.8925L7.40744 8.0025L12.2974 12.8925C12.6874 13.2825 13.3174 13.2825 13.7074 12.8925C14.0974 12.5025 14.0974 11.8725 13.7074 11.4825L8.81744 6.5925L13.7074 1.7025C14.0874 1.3225 14.0874 0.6825 13.7074 0.3025Z"
                fill="black"
            />
        </svg>
    );
};

export default Cancel;
